import React from 'react';
import { Card } from '../components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background p-4 lg:p-8">
      <div className="max-w-4xl mx-auto">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" /> Back
        </Button>

        <Card className="card-modern p-8">
          <h1 className="text-3xl font-bold text-foreground mb-6">Terms of Service</h1>
          <p className="text-muted-foreground mb-4">Last updated: March 2026</p>

          <div className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing or using Front Desk Pro ("Service"), you agree to be bound by these Terms of Service. 
                If you do not agree to these terms, please do not use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">2. Description of Service</h2>
              <p className="text-muted-foreground">
                Front Desk Pro provides AI-powered virtual receptionist services for businesses, including:
              </p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                <li>Automated phone call answering</li>
                <li>Appointment scheduling</li>
                <li>Customer inquiry handling</li>
                <li>SMS notifications and responses</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">3. User Responsibilities</h2>
              <p className="text-muted-foreground">You agree to:</p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                <li>Provide accurate business information</li>
                <li>Use the Service in compliance with applicable laws</li>
                <li>Not use the Service for fraudulent or deceptive purposes</li>
                <li>Maintain the confidentiality of your account credentials</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">4. Billing and Payments</h2>
              <p className="text-muted-foreground">
                Subscription fees are billed monthly. Usage charges (call minutes beyond your plan) 
                are billed at the rate specified in your plan. All payments are non-refundable except 
                as required by law.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">5. AI Disclosure</h2>
              <p className="text-muted-foreground">
                Front Desk Pro uses artificial intelligence to handle calls. The AI will identify 
                itself as an AI assistant when directly asked by callers. We do not represent that 
                the AI is a human operator.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">6. Limitation of Liability</h2>
              <p className="text-muted-foreground">
                Front Desk Pro is provided "as is" without warranties of any kind. We are not liable 
                for any indirect, incidental, or consequential damages arising from your use of the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">7. Contact</h2>
              <p className="text-muted-foreground">
                For questions about these Terms, please contact us at support@frontdeskpro.org
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Terms;
